import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Stack,
  Alert,
  InputAdornment,
  Button,
  TextField,
} from "@mui/material";
import { useDrawnPrizes } from "../../hooks/useDrawnPrizes";
import PrintIcon from "@mui/icons-material/PrintOutlined";
import { LotterySessionDto, PrizeDto } from "../../models/Lottery";
import ChristmasLoader from "../../Components/ChristmasLoader";
import { useFileDownload } from "../../hooks/useFileDownload";
import SearchIcon from "@mui/icons-material/Search";
import { useMemo, useState } from "react";

interface IRunLotteryDrawnPrizesProps {
  selectedLottery: LotterySessionDto;
}
export const RunLotteryDrawnPrizes = ({
  selectedLottery,
}: IRunLotteryDrawnPrizesProps) => {
  const { lotteryPrizes, loading } = useDrawnPrizes(
    selectedLottery.sessionId as string
  );
  const { download, isDownloading } = useFileDownload();
  const [search, setSearch] = useState<string>("");
  const filteredPrizes = useMemo(() => {
    if (!lotteryPrizes) return [];

    const term = search?.trim() ?? null;
    if (!term) return lotteryPrizes;

    return lotteryPrizes.filter((p: PrizeDto) => {
      return p.winningTicketNumber == (term as any);
    });
  }, [lotteryPrizes, search]);

  if (loading) return <ChristmasLoader />;

  if (lotteryPrizes.length === 0) {
    return (
      <Alert severity="info" sx={{ borderRadius: 2, fontSize: "1.5em" }}>
        Δεν έχουν κληρωθεί ακόμη δώρα για αυτή τη λοταρία.
      </Alert>
    );
  }

  return (
    <Stack spacing={2}>
      <Stack
        spacing={2}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack flex={1}>
          <TextField
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Αναζήτηση δώρου..."
            sx={{ bgcolor: "white", borderRadius: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "hsl(150, 20%, 45%)" }} />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <Stack>
          <Button
            variant="contained"
            size="large"
            color="error"
            disabled={isDownloading}
            onClick={() =>
              download(
                selectedLottery.sessionId as string,
                `lottery-${selectedLottery.sessionId}-prizes.pdf`
              )
            }
            startIcon={<PrintIcon />}
          >
            {isDownloading ? "Εκτυπώνεται..." : "Εκτύπωση"}
          </Button>
        </Stack>
      </Stack>
      <Card style={{ width: "100%" }}>
        <TableContainer>
          <Table size="medium">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell width={"60px"}>Φώτο</TableCell>
                <TableCell>Όνομα</TableCell>
                <TableCell>Περιγραφή</TableCell>
                <TableCell align="right">Ποσότητα</TableCell>
                <TableCell align="right">Λαχνός</TableCell>
                <TableCell align="center">Α/Α</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredPrizes?.map((row: PrizeDto, i) => (
                <TableRow
                  key={i}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell scope="row">{i + 1}</TableCell>
                  <TableCell padding="none" align="center">
                    {row.image ? (
                      <img
                        width={"100px"}
                        src={`data:image/jpeg;base64,${row.image}`}
                        alt={"noimage"}
                      />
                    ) : (
                      <Typography variant="h4">🎁</Typography>
                    )}
                  </TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell align="right">{row.quantity}</TableCell>
                  <TableCell align="right">{row.winningTicketNumber}</TableCell>
                  <TableCell align="center">
                    {row.referenceNumber ?? "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Stack>
  );
};
